import React from 'react';
import NextLink from 'next/link';
import { DataTestId } from '@Types/playwright';

interface LinkReference {
  type: 'link';
  link: string;
  target?: string;
  openInNewWindow: boolean;
}

interface PageFolderReference {
  type: 'page-folder';
  pageFolder: {
    pageFolderId: string;
    name: string;
    hasLivePage: boolean;
    _urls: {
      [locale: string]: string;
    };
    _url: string;
  };
  openInNewWindow: boolean;
}

export type Reference = LinkReference | PageFolderReference;

export const getReferenceTarget = (target: Reference): string => {
  switch (target.type) {
    case 'link':
      return target.link || target.target;
    case 'page-folder':
      return target.pageFolder._url;
    default:
      //Log.warn('Reference ', target, ' is not valid reference')
      return '/';
  }
};

export function getTargetProps(target: LinkReference | PageFolderReference) {
  if (target.openInNewWindow) {
    return {
      target: '_blank',
      rel: 'noopener',
    };
  }

  return {};
}

export function isLiveReference(reference: LinkReference | PageFolderReference) {
  return reference.type !== 'page-folder' || (reference.type === 'page-folder' && reference.pageFolder?.hasLivePage);
}

type Props = {
  className?: string;
  target: Reference;
  ariaLabel?: string;
  refObject?: React.MutableRefObject<any>;
} & DataTestId;

export const ReferenceLink: React.FC<Props> = ({ target, className, ariaLabel, children, refObject, ...props }) => {
  //no valid target for next/link
  if (!target)
    return (
      <NextLink href="#">
        <a aria-label={ariaLabel} className={className} ref={refObject} {...props}>
          {children}
        </a>
      </NextLink>
    );

  return (
    <NextLink href={getReferenceTarget(target)}>
      <a aria-label={ariaLabel} className={className} {...getTargetProps(target)} ref={refObject} {...props}>
        {children}
      </a>
    </NextLink>
  );
};
